// @ts-nocheck
/* The approved artist page script (03 Website Redesign/artist.html), ported 1:1 for /artist/<slug>.
   Only changes: runs inside the page root, the slug comes from the route, asset paths resolve to 1Dash.Pro Media Storage,
   links point at the live routes, listeners are cleaned up on unmount, internal photo-credit notes are not printed. */
import { tiAsset as __A } from '../../data/tripinkAssets';

export function initArtist(__root, __slug) {
  const __c = [];
  const __on = (t, e, f, o) => { t.addEventListener(e, f, o); __c.push(() => t.removeEventListener(e, f, o)); };

/* ===== CONFIG (same switches as the homepage) ===== */
const SHOW_RATES = false; // flip to true ONLY after the owner approves public rates, then fill "rate" per artist below
const BOOK = '/book-now';
const SMS = 'sms:702-408-8305';

/* thumbnail aspect ratios (h/w) so the grid never jumps while images load */
const AR = {"k-brian-traditional-snake-dagger-rose-b":1.345,"k-brian-traditional-snake-dagger-rose":1.345,"k-day-of-the-dead-half-sleeve-closeup":1.77,"k-day-of-the-dead-half-sleeve-woman-full":1.77,"k-desert-wolf-moon-sleeve-woman-b":0.566,"k-desert-wolf-moon-sleeve-woman":0.744,"k-halloween-neon-sketchbook-skull-dice-b":0.566,"k-halloween-neon-sketchbook-skull-dice":0.566,"k-lion-roses-forearm-blur-c":1.77,"k-mobster-sleeve-no-face-a":1.77,"k-mobster-sleeve-no-face-b":1.77,"k-rich-horror-monster-roses-sketch-b":1.77,"k-rich-horror-monster-roses-sleeve-sketch":1.77,"k-rose-hummingbird-shoulder-blur-a":0.667,"k-rose-hummingbird-shoulder-blur-b":0.744,"k-surreal-hourglass-back-lion-astronaut-a":1.77,"k-surreal-hourglass-back-lion-astronaut-b":1.77,"k-vegas-back-roulette-showgirl-a":1.77,"k-vegas-back-roulette-showgirl-b":1.77,"k-vegas-chest-piece-pinup-cards-b":0.744,"k-vegas-chest-piece-pinup-cards":0.744,"k-vegas-dice-cards-sleeve-side-b":0.744,
"vault-rick-trip_black-grey_back_01":0.995,"vault-rick-trip_black-grey_hand_01":0.88,"vault-rick-trip_black-grey_sleeve_01":0.988,"vault-rick-trip_color-realism_back_01":0.995,"vault-rick-trip_color-realism_back_02":0.988,"vault-rick-trip_color-realism_chest_01":0.991,"vault-rick-trip_color-realism_sleeve_01":0.986,"vault-rick-trip_color-realism_small_01":0.986,"vault-rick-trip_horror_arm_01":1.056,"vault-rick-trip_horror_leg_01":1.333,"vault-rick-trip_horror_sleeve_01":1.0,"vault-rick-trip_japanese_sleeve_01":0.995,"vault-rick-trip_japanese_sleeve_02":1.005,"vault-rick-trip_neo-trad_forearm_01":1.033,"vault-rick-trip_neo-trad_forearm_02":0.928,"vault-rick-trip_other_hand_01":0.994,"vault-rick-trip_portrait_leg_01":1.002,"vault-rick-trip_traditional_arm_01":0.978,
"w-7084":1.37,"w-7085":1.42,"w-7090":2.212,"w-7092":1.614,"w-7093":1.847,"w-7095":1.322,"w-7096":1.641,"w-7097":1.573,"w-7098":1.245,"w-7099":1.837,"w-7101":1.781,"w-7104":2.011,"w-7105":2.016,"w-7106":2.724,"w-7107":1.489,"w-7108":1.917,"w-7110":1.712,"w-7111":2.045,"w-7112":2.078,"w-7113":2.448,"w-7115":2.097,"w-7116":2.244,"w-7117":1.481,"w-7118":1.483,"w-7120":1.661,"w-71211":1.255,"w-71221":1.214,"w-7123c":1.303};

/* ===== ARTISTS =====
   bio: ONLY facts from Trip Ink records. ph: honest placeholders, rendered with a "to confirm" tag.
   work: real photos (f = asset file name without .jpg). concepts: design concepts, shown ONLY in the labeled concepts strip. */
const ARTISTS = [
 {slug:'rick-trip', id:'rick', name:'Rick Trip', first:'Rick', last:'Trip', book:'Rick', role:'Owner + Lead Artist', ig:'ricktrip',
  tags:['Pop-culture color','Horror','Dark realism','Japanese','Neo-traditional'],
  chips:[['OWNER','Lead artist','g']],
  lead:'Rick Trip owns Trip Ink Tattoo Company and is its lead artist.',
  bio:['He is known across the tattoo, art, music and film world.',
       'His specialty is pop-culture color and horror. The work below runs from comic and anime characters to dark black-and-grey realism, Japanese sleeves and neo-traditional pieces.'],
  ph:['How Rick got started, his years tattooing and the projects he is proudest of.'],
  file:[['Role','Owner + lead artist'],['Known for','Pop-culture color + horror'],['Books','Full days'],['Years tattooing','tbc'],['Based at','Trip Ink, Hot Rod City, Las Vegas']],
  rate:'', open:'', hero:['w-7118','w-7112','w-7120'],
  work:[
   {f:'w-7118',t:'Comic mutant in full color',s:['Pop Culture','Color'],src:'IMG_7118',cr:'likely'},
   {f:'w-7112',t:'Killer clown half sleeve',s:['Horror','Color','Pop Culture'],src:'IMG_7112',cr:'likely'},
   {f:'w-7120',t:'Anime warrior',s:['Anime','Pop Culture','Color'],src:'IMG_7120',cr:'likely'},
   {f:'w-7116',t:'Sugar-skull lady sleeve',s:['Black & Grey','Realism'],src:'IMG_7116',cr:'likely'},
   {f:'w-7117',t:'Pocket watch, key + roses',s:['Color','Neo-Traditional'],src:'IMG_7117',cr:'likely'},
   {f:'w-7115',t:'Dark skull portrait sleeve',s:['Black & Grey','Horror','Realism'],src:'IMG_7115',cr:'likely'},
   {f:'w-7113',t:'Black + grey full sleeve',s:['Black & Grey'],src:'IMG_7113',cr:'likely'},
   {f:'vault-rick-trip_color-realism_back_01',t:'Sugar skull full back',s:['Color','Realism'],src:'archive'},
   {f:'vault-rick-trip_color-realism_back_02',t:'Biomech demon back piece',s:['Color','Horror'],src:'archive'},
   {f:'vault-rick-trip_japanese_sleeve_01',t:'Koi + waves sleeve',s:['Japanese','Color'],src:'archive'},
   {f:'vault-rick-trip_japanese_sleeve_02',t:'Dragon + foo dog chest and arm',s:['Japanese','Color'],src:'archive'},
   {f:'vault-rick-trip_color-realism_chest_01',t:'Glowing-eye ghost',s:['Color','Horror'],src:'archive'},
   {f:'vault-rick-trip_horror_arm_01',t:'Vampire demon',s:['Horror','Black & Grey'],src:'archive'},
   {f:'vault-rick-trip_horror_leg_01',t:'Girl + skull leg piece',s:['Horror','Black & Grey','Realism'],src:'archive'},
   {f:'vault-rick-trip_horror_sleeve_01',t:'Girl + skull sleeve',s:['Horror','Black & Grey','Realism'],src:'archive'},
   {f:'vault-rick-trip_black-grey_back_01',t:'Skull + knuckles shoulder',s:['Black & Grey','Horror'],src:'archive'},
   {f:'vault-rick-trip_black-grey_sleeve_01',t:'Skull + portrait sleeve',s:['Black & Grey','Realism'],src:'archive'},
   {f:'vault-rick-trip_black-grey_hand_01',t:'Ripped-skin biomech hand',s:['Black & Grey'],src:'archive'},
   {f:'vault-rick-trip_portrait_leg_01',t:'Vampire portrait',s:['Realism','Black & Grey'],src:'archive'},
   {f:'vault-rick-trip_color-realism_sleeve_01',t:'Biomech skull sleeve',s:['Color','Horror'],src:'archive'},
   {f:'vault-rick-trip_neo-trad_forearm_01',t:'Skull + flowers',s:['Neo-Traditional','Color'],src:'archive'},
   {f:'vault-rick-trip_neo-trad_forearm_02',t:'Butterfly + rose',s:['Neo-Traditional','Color'],src:'archive'},
   {f:'vault-rick-trip_traditional_arm_01',t:'Blue rose',s:['Traditional','Color'],src:'archive'},
   {f:'vault-rick-trip_color-realism_small_01',t:'Blue butterfly',s:['Small','Color'],src:'archive'},
   {f:'vault-rick-trip_other_hand_01',t:'Celtic ring tattoos',s:['Small'],src:'archive'}
  ],
  concepts:[
   {f:'k-halloween-neon-sketchbook-skull-dice',t:'Skull + dice sketchbook'},
   {f:'k-halloween-neon-sketchbook-skull-dice-b',t:'Skull + dice sketchbook, alt'},
   {f:'k-vegas-dice-cards-sleeve-side-b',t:'Dice + cards sleeve'},
   {f:'k-surreal-hourglass-back-lion-astronaut-b',t:'Hourglass city back piece'}
  ]},
 {slug:'rich-pineda', id:'rich', name:'Rich Pineda', first:'Rich', last:'Pineda', book:'Rich', ig:'richpinedaart333', verified:true,
  tags:['Horror realism','Movie + music icons','Color','Black & grey'],
  chips:[['19.5K','IG followers','g'],['&#10003;','Verified','k']],
  lead:'Rich Pineda tattoos color and black-and-grey realism, with a focus on horror, movie and music icons.',
  bio:['His Instagram, @richpinedaart333, is verified, with about 19.5K followers.'],
  ph:['Rich\'s background, years tattooing and favorite projects.'],
  file:[['Known for','Horror + movie realism'],['Works in','Color + black & grey'],['Instagram','Verified, about 19.5K followers'],['Books','Full days'],['Years tattooing','tbc']],
  rate:'', open:'', hero:['w-7095','w-7096','w-7093'],
  work:[
   {f:'w-7096',t:'Ghost-hunter movie portrait',s:['Portrait','Pop Culture','Color'],src:'IMG_7096',cr:'likely'},
   {f:'w-7095',t:'Horror movie icon sleeves',s:['Horror','Pop Culture','Color'],src:'IMG_7095',cr:'likely'},
   {f:'w-7093',t:'Classic monsters sleeve',s:['Horror','Black & Grey','Realism'],src:'IMG_7093',cr:'likely'},
   {f:'w-7111',t:'Skeleton cowboy',s:['Black & Grey','Horror'],src:'IMG_7111',cr:'likely'}
  ],
  concepts:[
   {f:'k-rich-horror-monster-roses-sleeve-sketch',t:'Monster + roses sleeve sketch'},
   {f:'k-rich-horror-monster-roses-sketch-b',t:'Monster + roses sketch, alt'},
   {f:'k-surreal-hourglass-back-lion-astronaut-a',t:'Hourglass city back piece'},
   {f:'k-vegas-chest-piece-pinup-cards-b',t:'Vegas pin-up chest piece'}
  ]},
 {slug:'brian', id:'brian', name:'Brian', first:'Brian', last:'', book:'Brian', aka:'Brian Giacobone', ig:'brian_g_tattoos',
  tags:['American traditional','Bold color','Flash'],
  chips:[['TRAD','American','k']],
  lead:'Brian is Trip Ink\'s American traditional specialist.',
  bio:['Bold lines, solid color and classic flash: snakes, skulls, roses and lady heads.'],
  ph:['Brian\'s background, years tattooing and favorite flash to tattoo.'],
  file:[['Known for','American traditional'],['Books','Full days'],['Years tattooing','tbc']],
  rate:'', open:'', hero:['w-7085','w-7092','w-7090'],
  work:[
   {f:'w-7092',t:'Wolf-headdress lady',s:['Traditional','Flash','Color'],src:'IMG_7092'},
   {f:'w-7085',t:'Lady head in black',s:['Traditional','Black & Grey'],src:'IMG_7085'},
   {f:'w-7090',t:'Vampire + skull forearm',s:['Traditional','Horror','Color'],src:'IMG_7090'},
   {f:'w-7084',t:'Snake + skull flash',s:['Traditional','Flash','Color'],src:'IMG_7084'}
  ],
  concepts:[
   {f:'k-brian-traditional-snake-dagger-rose',t:'Snake, dagger + rose'},
   {f:'k-brian-traditional-snake-dagger-rose-b',t:'Snake, dagger + rose, alt'}
  ]},
 {slug:'sophia-mae', id:'sophia', name:'Sophia Mae', first:'Sophia', last:'Mae', book:'Sophia', role:'Resident Piercer', ig:'sophia_mae113',
  tags:['Color','Anime','Illustrative','Piercing'],
  chips:[['PIERCER','Resident','p']],
  lead:'Sophia Mae works in color, anime and illustrative styles.',
  bio:['Her work runs from character portraits to full landscape sleeves. She is also Trip Ink\'s resident piercer, by appointment.'],
  ph:['Sophia\'s background, years tattooing and piercing, and favorite pieces.'],
  file:[['Known for','Color, anime + illustrative'],['Also','Resident piercer'],['Books','Full days + piercing appointments'],['Years tattooing','tbc']],
  rate:'', open:'', hero:['w-7099','w-7097','w-7098'],
  work:[
   {f:'w-7097',t:'Pirate captain portrait',s:['Portrait','Color','Realism'],src:'IMG_7097',cr:'likely'},
   {f:'w-7098',t:'Landscape sleeves',s:['Color','Landscape'],src:'IMG_7098',cr:'likely'},
   {f:'w-7099',t:'Palm-tree sunset sleeve',s:['Color','Landscape'],src:'IMG_7099',cr:'likely'},
   {f:'w-7101',t:'Anime character illustration',s:['Anime','Illustrative'],src:'IMG_7101',cr:'likely'}
  ],
  concepts:[
   {f:'k-day-of-the-dead-half-sleeve-closeup',t:'Day of the Dead half sleeve'},
   {f:'k-day-of-the-dead-half-sleeve-woman-full',t:'Day of the Dead, full view'}
  ]},
 {slug:'dr-valerio', id:'valerio', name:'Dr. Valerio', first:'Dr.', last:'Valerio', book:'Dr. Valerio', ig:'dr.valerio_tattoo',
  tags:['Custom','Realism','Black & grey','Color','Fine line'],
  chips:[['40','Years','g']],
  lead:'Dr. Valerio has been tattooing for 40 years.',
  bio:['He works across custom pieces, realism, black and grey, color and fine line.'],
  ph:['Where Dr. Valerio trained, his story and the pieces he likes best.'],
  file:[['Experience','40 years tattooing'],['Works in','Custom, realism, B&amp;G, color, fine line'],['Books','Full days']],
  rate:'', open:'', hero:['w-7106','w-7108','w-7110'],
  work:[
   {f:'w-7108',t:'Red koi full sleeve',s:['Japanese','Color'],src:'IMG_7108',cr:'likely'},
   {f:'w-7106',t:'Rose cascade arm',s:['Color','Floral'],src:'IMG_7106',cr:'likely'},
   {f:'w-7110',t:'Rose + hummingbird',s:['Color','Floral'],src:'IMG_7110',cr:'likely'},
   {f:'w-7107',t:'Watercolor scorpion',s:['Color','Watercolor'],src:'IMG_7107',cr:'likely'}
  ],
  concepts:[
   {f:'k-mobster-sleeve-no-face-a',t:'Mobster + dice sleeve'},
   {f:'k-mobster-sleeve-no-face-b',t:'Mobster sleeve, alt'},
   {f:'k-desert-wolf-moon-sleeve-woman',t:'Desert wolf + moon sleeve'},
   {f:'k-rose-hummingbird-shoulder-blur-b',t:'Rose + hummingbird shoulder'},
   {f:'k-rose-hummingbird-shoulder-blur-a',t:'Rose + hummingbird, alt'}
  ]},
 {slug:'casso', id:'casso', name:'Casso', first:'Casso', last:'', book:'Casso', ig:'casso_ink',
  tags:['Black & grey','Vegas realism','Gambling themes'],
  chips:[['B&amp;G','Realism','k']],
  lead:'Casso tattoos black-and-grey realism with a Las Vegas edge.',
  bio:['Think playing cards, 8-balls, dice, roulette and casino chips, plus big statue-style figures.'],
  ph:['Casso\'s background, years tattooing and favorite projects.'],
  file:[['Known for','Black &amp; grey Vegas realism'],['Books','By session'],['Years tattooing','tbc']],
  rate:'', open:'', hero:['w-7105','w-7104'],
  work:[
   {f:'w-7105',t:'Cards, 8-ball + dice sleeve',s:['Black & Grey','Vegas','Realism'],src:'IMG_7105'},
   {f:'w-7104',t:'Atlas holding the world',s:['Black & Grey','Realism'],src:'IMG_7104'}
  ],
  concepts:[
   {f:'k-vegas-chest-piece-pinup-cards',t:'Pin-up + aces chest piece'},
   {f:'k-lion-roses-forearm-blur-c',t:'Lion + roses forearm'},
   {f:'k-vegas-back-roulette-showgirl-a',t:'Roulette + showgirl back'},
   {f:'k-vegas-back-roulette-showgirl-b',t:'Roulette + showgirl, alt'}
  ]},
 {slug:'chris', id:'chris', name:'Chris', first:'Chris', last:'', book:'Chris', aka:'Chrystian Oliveira', ig:'chrys.ink.tattoo',
  tags:['Fine line','Small pieces','First tattoos'],
  chips:[['FINE','Line','p']],
  lead:'Chris handles Trip Ink\'s fine-line and small pieces.',
  bio:['Stars, symbols, butterflies and first tattoos, so the full-day crew can stay on the big work.'],
  ph:['Chris\'s background, years tattooing and favorite small designs.'],
  file:[['Known for','Fine line + small pieces'],['Books','Small pieces by appointment'],['Years tattooing','tbc']],
  rate:'', open:'', hero:['w-7123c','w-71221','w-71211'],
  work:[
   {f:'w-7123c',t:'Fine-line north star',s:['Fine Line','Small'],src:'IMG_7123 (his Instagram post, cropped)'},
   {f:'w-71221',t:'Fine-line butterfly',s:['Fine Line','Small'],src:'IMG_71221'},
   {f:'w-71211',t:'Yin-yang',s:['Small'],src:'IMG_71211'}
  ],
  concepts:[]}
];
AR['w-7123c']=1.303;

/* ===== pick the artist ===== */
const qs = new URLSearchParams(location.search).get('a');
const A = ARTISTS.find(x=>x.slug===(__slug||qs)) || ARTISTS[0];
const IDX = ARTISTS.indexOf(A);
const bookURL = `${BOOK}?artist=${A.id}`;
const esc = s => String(s).replace(/&(?!#?\w+;)/g,'&amp;').replace(/</g,'&lt;');
const tbc = '<span class="tbc">to confirm</span>';
const thumb = f => `${__A('t-'+(f)+'.jpg')}`, full = f => `${__A(''+(f)+'.jpg')}`;
const rate = (SHOW_RATES && A.rate) ? A.rate : (A.id==='casso' ? 'Session rate on request' : (A.id==='chris' ? 'Rate on request' : 'Full-day rate on request'));
document.title = `${A.name} | Las Vegas Tattoo Artist | Trip Ink Tattoo`;
(document.querySelector('meta[name=description]')||{}).content = `${A.name}, Las Vegas tattoo artist at Trip Ink Tattoo. ${A.tags.join(', ')}. See real work and book a day.`;
['navBook','barBook','lbBook'].forEach(id=>{ const el=document.getElementById(id); el.href=bookURL; });
document.getElementById('navBook').textContent = `Book ${A.book}`;
document.getElementById('barBook').textContent = `Book ${A.book}`;
document.getElementById('lbBook').textContent = `Book ${A.book}`;

/* ===== build the page ===== */
const heroW = A.hero.map(f=>A.work.find(w=>w.f===f)).filter(Boolean);
const fanOrder = heroW.length>=3 ? [heroW[1],heroW[2],heroW[0]] : (heroW.length===2 ? [heroW[1],heroW[0]] : heroW);
const credit = w => '';

// filter tags with counts, most common first
const tagCount = {}; A.work.forEach(w=>w.s.forEach(t=>tagCount[t]=(tagCount[t]||0)+1));
const tagList = Object.entries(tagCount).filter(([,n])=>n>0).sort((a,b)=>b[1]-a[1]||a[0].localeCompare(b[0]));

const crew = ARTISTS.filter(x=>x!==A);
const page = `
<header class="ahero" id="top">
  <div class="bgph" style="background-image:url('${thumb(A.hero[0])}')"></div>
  <div class="grain" aria-hidden="true"></div>
  <div class="ghost" aria-hidden="true">${esc(A.first==='Dr.'?A.last:A.first)}</div>
  <div class="acopy">
    <div class="crumb"><a href="/">Trip Ink</a><span>/</span><a href="/#crew">The Crew</a><span>/</span>Bay 0${IDX+1}</div>
    <span class="eyebrow">Las Vegas Tattoo Artist</span>
    <h1 class="aname"><span class="first chrome">${esc(A.last ? A.first : A.name)}</span>${A.last?`<span class="last"><span>${esc(A.last)}</span></span>`:''}</h1>
    ${A.aka?`<p class="aka">Also known as <b>${esc(A.aka)}</b></p>`:''}${A.role?`<p class="aka"><b>${esc(A.role)}</b></p>`:''}
    <div class="tags">${A.tags.map(t=>`<span>${esc(t)}</span>`).join('')}</div>
    <div class="tickets">
      <div class="ticket ig"><small>Instagram</small><b><a href="https://www.instagram.com/${A.ig}/" target="_blank" rel="noopener">@${A.ig}</a>${A.verified?' &#10003;':''}</b></div>
      <div class="ticket"><small>Rate</small><b>${rate}</b></div>
      <div class="ticket"><small>Next open day</small><b>${A.open ? esc(A.open) : tbc}</b></div>
    </div>
    <div class="acta">
      <a class="btn solid" href="${bookURL}" data-book>Book ${esc(A.book)} <span class="arr">&rarr;</span></a>
      <a class="btn" href="${SMS}">Text the Shop</a>
    </div>
    <div class="facts" aria-label="Quick facts">
      ${A.chips.map(([b,s,c])=>`<div class="pchip ${c||''}"><span>${b}<small>${s}</small></span></div>`).join('')}
      <div class="pchip"><span>${A.work.length}<small>Pieces here</small></span></div>
    </div>
  </div>
  <div class="fan ${fanOrder.length===1?'one':''}" aria-label="Featured work by ${esc(A.name)}">
    ${fanOrder.map((w,i)=>`<button type="button" class="${i===fanOrder.length-1?'mid':''}" data-open="${A.work.indexOf(w)}" aria-label="View ${esc(w.t)}">${credit(w)}<img src="${full(w.f)}" alt="${esc(w.t)}, tattoo by ${esc(A.name)}" ${i===fanOrder.length-1?'fetchpriority="high"':'loading="lazy"'} decoding="async"></button>`).join('')}
    <span class="lbl">Tap to open &middot; <b>${A.work.length}</b> real pieces</span>
  </div>
</header>

<section class="about" id="about">
  <div class="wrap">
    <div class="bio rv">
      <div class="bulbrow" data-n="7"></div>
      <span class="eyebrow">Meet ${esc(A.book)}</span>
      <h2 class="title chrome">The Artist</h2>
      <p class="lead1">${A.lead}</p>
      ${A.bio.map(p=>`<p>${p}</p>`).join('')}
      ${A.ph.map(p=>`<p class="ph">${p} ${tbc}</p>`).join('')}
      <div class="word">
        <div class="q">A word from ${esc(A.book)}: coming soon. ${tbc}</div>
        <div class="w">Comes from ${esc(A.book)}'s <a href="/artist-interview">artist interview</a>. We never write it for them.</div>
      </div>
    </div>
    <aside class="file rv" style="--d:.15s" aria-label="Fact file">
      <h3>Fact File <small>BAY 0${IDX+1}</small></h3>
      <dl>
        <dt>Name</dt><dd>${esc(A.name)}${A.aka?` (${esc(A.aka)})`:''}</dd>
        ${A.file.map(([k,v])=>`<dt>${k}</dt><dd>${v==='tbc'?tbc:v}</dd>`).join('')}
        <dt>Instagram</dt><dd><a href="https://www.instagram.com/${A.ig}/" target="_blank" rel="noopener">@${A.ig}</a></dd>
        <dt>Next open day</dt><dd>${A.open?esc(A.open):tbc}</dd>
        <dt>Rate</dt><dd>${rate}</dd>
      </dl>
    </aside>
  </div>
</section>

<section class="work" id="work">
  <div class="head rv">
    <div><div class="bulbrow" data-n="9"></div><span class="eyebrow">Real work, real skin</span><h2 class="title neon">${esc(A.first==='Dr.'?A.name:A.first)}'s Portfolio</h2></div>
    <div class="count" id="count"></div>
  </div>
  <div class="chipsbar rv" role="group" aria-label="Filter by style">
    <span class="lab">Filter by style</span>
    <button class="fchip" type="button" data-f="*" aria-pressed="true">All<i>${A.work.length}</i></button>
    ${tagList.map(([t,n])=>`<button class="fchip" type="button" data-f="${esc(t)}" aria-pressed="false">${esc(t)}<i>${n}</i></button>`).join('')}
  </div>
  <div class="mas ${A.work.length<5?'few':''}" id="mas">
    ${A.work.map((w,i)=>`<figure class="it" data-s="${esc(w.s.join('|'))}">${credit(w)}<button type="button" data-open="${i}" aria-label="View ${esc(w.t)}"><img src="${thumb(w.f)}" width="640" height="${Math.round(640*(AR[w.f]||1.3))}" alt="${esc(w.t)}, ${esc(w.s.join(', ').toLowerCase())} tattoo by ${esc(A.name)}" loading="lazy" decoding="async"><figcaption class="cap"><b>${esc(w.t)}</b><span>${esc(w.s.join(' · '))}</span></figcaption></button></figure>`).join('')}
  </div>
</section>

<section class="concepts" id="concepts">
  <div class="head rv">
    <div class="bulbrow" data-n="7"></div>
    <span class="eyebrow">Ideas to start from</span>
    <h2 class="title chrome">Design concepts in ${esc(A.book)}'s style &mdash; customized by your artist</h2>
    <span class="disc">These are design concepts, not finished tattoos. ${esc(A.book)} redraws and customizes every piece for you.</span>
  </div>
  ${A.concepts.length ? `<div class="cgrid">${A.concepts.map((c,i)=>`<div class="cc rv" style="--d:${(i%6)*.06}s"><button type="button" data-concept="${i}" aria-label="View design concept: ${esc(c.t)}"><span class="stamp">DESIGN CONCEPT</span><img src="${thumb(c.f)}" alt="${esc(c.t)}, design concept" loading="lazy" decoding="async"></button><h3>${esc(c.t)}</h3><p>Concept &middot; customized by ${esc(A.book)}</p></div>`).join('')}</div>`
    : `<div class="cempty rv">Concepts in ${esc(A.book)}'s style are in the next design batch. ${tbc}</div>`}
</section>

<section class="revs" id="reviews">
  <div class="revcard rv">
    <div class="qm" aria-hidden="true">&ldquo;</div>
    <div>
      <div class="stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
      <h3 class="chrome">What clients say about ${esc(A.book)}</h3>
      <p>Artist-specific reviews: ${tbc} We only show reviews that name ${esc(A.book)}, never quotes written for another artist.</p>
    </div>
    <div class="side">
      <a class="btn sm" href="/#reviews">Read shop reviews</a>
      <a class="btn sm solid" href="${bookURL}" data-book>Book ${esc(A.book)}</a>
    </div>
  </div>
</section>

<section class="bookband" id="book">
  <div class="head rv" style="display:flex;flex-direction:column;align-items:center">
    <div class="bulbrow" data-n="9"></div>
    <span class="eyebrow">Ready when you are</span>
    <h2 class="title neon">Lock in ${esc(A.book)}</h2>
    <p class="sub" style="margin-inline:auto">Trip Ink works by appointment. Here is how a request turns into your day.</p>
  </div>
  <div class="steps3">
    <div class="s3 rv"><div class="n">01</div><h3>Send your idea</h3><p>Tell us what you want, where it goes and your dates. Ask for ${esc(A.book)} by name.</p></div>
    <div class="s3 rv" style="--d:.1s"><div class="n">02</div><h3>Stef matches your day</h3><p>Requests are first come, first served. Nothing is booked until Stef confirms ${esc(A.book)}'s day with you.</p></div>
    <div class="s3 rv" style="--d:.2s"><div class="n">03</div><h3>Deposit, then ink</h3><p>The deposit is taken only after your artist is confirmed. Amount ${tbc}</p></div>
  </div>
  <div class="acta rv"><a class="btn solid" href="${bookURL}" data-book>Book ${esc(A.book)} <span class="arr">&rarr;</span></a><a class="btn" href="${SMS}">Text the Shop</a></div>
</section>

<section class="crewrow" id="crew">
  <div class="head rv"><div class="bulbrow" data-n="7"></div><span class="eyebrow">Not quite your style?</span><h2 class="title chrome">More from the crew</h2></div>
  <div class="cgrid6">
    ${crew.map((c,i)=>`<a class="mini rv" style="--d:${i*.06}s" href="/artist/${c.slug}"><img src="${thumb(c.hero[0])}" alt="Tattoo by ${esc(c.name)}" loading="lazy" decoding="async"><span class="t"><b>${esc(c.name)}</b><span>${esc(c.tags.slice(0,2).join(' · '))}</span><i>View profile &rarr;</i></span></a>`).join('')}
  </div>
  <p class="upd">Are you ${esc(A.book)}? <a href="/artist-interview?artist=${A.id}">Update your profile</a></p>
</section>`;
document.getElementById('page').innerHTML = page;

/* ===== filters ===== */
const items = [...__root.querySelectorAll('#mas .it')];
const countEl = document.getElementById('count');
function setCount(n,f){ countEl.innerHTML = `Showing <b>${n}</b> of ${A.work.length}${f!=='*'?` &middot; ${esc(f)}`:''}`; }
setCount(items.length,'*');
__root.querySelectorAll('.fchip').forEach(b=>b.addEventListener('click',()=>{
  const f=b.dataset.f; __root.querySelectorAll('.fchip').forEach(x=>x.setAttribute('aria-pressed',x===b?'true':'false'));
  let n=0; items.forEach(it=>{ const on = f==='*' || it.dataset.s.split('|').includes(f); it.hidden=!on; if(on) n++; });
  setCount(n,f);
}));

/* ===== lightbox: real work and concepts are separate sets ===== */
const lb=document.getElementById('lb'), lbImg=document.getElementById('lbImg');
let set=[], pos=0, kind='work';
function visibleWork(){ return items.filter(it=>!it.hidden).map(it=>+it.querySelector('[data-open]').dataset.open); }
function show(){
  const i=set[pos]; const w = kind==='work' ? A.work[i] : A.concepts[i];
  lbImg.classList.add('ld'); lbImg.onload=()=>lbImg.classList.remove('ld');
  lbImg.src = full(w.f); lbImg.alt = kind==='work' ? `${w.t}, tattoo by ${A.name}` : `${w.t}, design concept`;
  document.getElementById('lbT').textContent = w.t;
  document.getElementById('lbS').textContent = kind==='work' ? `${w.s.join(' · ')} · by ${A.name}` : `Design concept, customized by ${A.book}. Not a finished tattoo.`;
  const k=document.getElementById('lbKind'); k.textContent = kind==='work' ? 'Real work' : 'Design concept'; k.classList.toggle('con',kind!=='work');
  document.getElementById('lbNum').textContent = `${pos+1} / ${set.length}`;
  const one = set.length<2; document.getElementById('lbP').hidden=one; document.getElementById('lbN').hidden=one;
  [1,-1].forEach(d=>{ const j=set[(pos+d+set.length)%set.length]; const ww = kind==='work'?A.work[j]:A.concepts[j]; if(ww) (new Image()).src=full(ww.f); });
}
function openLB(k,idx){ kind=k; set = k==='work' ? visibleWork() : A.concepts.map((_,i)=>i); if(!set.includes(idx)) set = k==='work' ? A.work.map((_,i)=>i) : set; pos=Math.max(0,set.indexOf(idx)); show(); lb.showModal(); }
function step(d){ pos=(pos+d+set.length)%set.length; show(); }
__on(document,'click',e=>{
  const o=e.target.closest('[data-open]'); if(o){ openLB('work',+o.dataset.open); return; }
  const c=e.target.closest('[data-concept]'); if(c){ openLB('concept',+c.dataset.concept); }
});
document.getElementById('lbP').onclick=()=>step(-1);
document.getElementById('lbN').onclick=()=>step(1);
document.getElementById('lbX').onclick=()=>lb.close();
lb.addEventListener('click',e=>{ if(e.target===lb || e.target.id==='lbStage') lb.close(); });
__on(document,'keydown',e=>{ if(!lb.open) return; if(e.key==='ArrowRight'){e.preventDefault();step(1);} if(e.key==='ArrowLeft'){e.preventDefault();step(-1);} });
let sx=null, sy=null;
const stage=document.getElementById('lbStage');
stage.addEventListener('touchstart',e=>{ sx=e.touches[0].clientX; sy=e.touches[0].clientY; },{passive:true});
stage.addEventListener('touchend',e=>{ if(sx===null) return; const dx=e.changedTouches[0].clientX-sx, dy=e.changedTouches[0].clientY-sy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) step(dx<0?1:-1); sx=null; },{passive:true});

/* ===== nav, bulbs, reveal ===== */
const nav=document.getElementById('nav');
__on(window,'scroll',()=>nav.classList.toggle('solid',scrollY>40),{passive:true});
document.getElementById('burger').onclick=()=>nav.classList.toggle('open');
__root.querySelectorAll('.links a').forEach(a=>a.addEventListener('click',()=>nav.classList.remove('open')));
__root.querySelectorAll('.bulbrow').forEach(b=>{ const n=+b.dataset.n||9; b.innerHTML=Array.from({length:n},(_,i)=>`<i style="--i:${i}"></i>`).join(''); });
const io='IntersectionObserver' in window ? new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }),{threshold:.12,rootMargin:'0px 0px -5% 0px'}) : null;
__root.querySelectorAll('.rv').forEach(el=>io?io.observe(el):el.classList.add('in'));
if(location.hash==='#static') __root.querySelectorAll('.rv').forEach(el=>el.classList.add('in'));

  __c.push(() => { try { io && io.disconnect(); } catch (e) {} try { lb.open && lb.close(); } catch (e) {} });
  return () => { __c.forEach((f) => { try { f(); } catch (e) {} }); };
}
